import type { Genome } from './types';
import {
  ALL_BODY_GENES,
  ALL_EAR_GENES,
  ALL_EYES_GENES,
  ALL_MOUTH_GENES,
  ALL_EGG_PATTERNS,
  ALL_HORN_GENES,
  ALL_MARKING_GENES,
  ALL_TAIL_GENES,
} from './types';
import { randomAlchemyType } from './alchemy';

type Rng = () => number;

function pick<T>(list: ReadonlyArray<T>, rng: Rng): T {
  const idx = Math.min(Math.floor(rng() * list.length), list.length - 1);
  return list[idx]!;
}

export function randomGenome(rng: Rng = Math.random): Genome {
  return {
    body: pick(ALL_BODY_GENES, rng),
    eyes: pick(ALL_EYES_GENES, rng),
    mouth: pick(ALL_MOUTH_GENES, rng),
    ears: pick(ALL_EAR_GENES, rng),
    horns: pick(ALL_HORN_GENES, rng),
    tail: pick(ALL_TAIL_GENES, rng),
    markings: pick(ALL_MARKING_GENES, rng),
    paletteHue: Math.floor(rng() * 360),
    bodyPredisposition: 50,
    eggPattern: pick(ALL_EGG_PATTERNS, rng),
    primaryTypes: [randomAlchemyType(rng)],
    modifiers: [],
    inheritedTraits: [],
  };
}
